import * as React from 'react';

import { calculateAverageTransactions } from '../../../providers/TransactionsProvider';
import { toCurrency } from '../../../utils/formatting';
import { type CalendarDateRange } from '../../DateRangePicker';
import Widget from '../../Widget';

import type { ColumnTable } from 'arquero';

export interface IAverageTransactionsRowProps {
  transactions: ColumnTable | null;
  dateRange: CalendarDateRange;
  colored?: boolean;
  showSign?: boolean;
  negateAmount?: boolean;
}

const AverageTransactionsRow = ({
  transactions,
  dateRange,
  colored = false,
  showSign = false,
  negateAmount = false,
}: IAverageTransactionsRowProps) => {
  const rawValue = React.useMemo(
    () => calculateAverageTransactions(transactions, dateRange),
    [transactions, dateRange]
  );

  const value = negateAmount ? -rawValue : rawValue;

  const valueClassName = React.useMemo(() => {
    if (colored) {
      return value >= 0 ? 'text-success-primary' : 'text-error-primary';
    }
    return '';
  }, [colored, value]);

  const formattedValue = toCurrency(value, { showSign });

  return <Widget.Row label="Average transaction" value={formattedValue} valueClassName={valueClassName} />;
};

export default AverageTransactionsRow;
